(() => {
  'use strict';
  if (window.LampsRoomEvents) return;
  const eventTypes = {
    room_generation_completed: 'preview_view',
    room_preview_reopened: 'preview_view',
    room_preview_product_clicked: 'product_click',
    room_share_opened: 'share_view',
    room_preview_shared: 'share',
    room_share_product_clicked: 'product_click',
    room_share_create_own_clicked: 'create_own_click',
    room_result_added_to_cart: 'add_to_cart',
    room_share_added_to_cart: 'add_to_cart',
    room_preview_downloaded: 'download',
    room_preview_rated: 'rating',
    room_try_again: 'retry',
    room_regenerate_requested: 'retry',
    room_email_offer_shown: 'email_offer',
    room_preview_emailed: 'email_request',
  };
  // Reach and QR handoff steps (#1911). They happen before any preview exists, so they
  // carry the visitor instead of a job, and they mint the visitor id: counting the people
  // who saw the button and never used it needs one for them too.
  const reachTypes = {
    room_button_shown: 'button_shown',
    room_button_seen: 'button_seen',
    room_preview_opened: 'tool_opened',
    room_photo_selected: 'photo_selected',
    room_handoff_opened: 'handoff_opened',
    room_handoff_arrived: 'handoff_arrived',
    room_handoff_continued_on_desktop: 'handoff_continued',
  };
  // Shown and seen fire on every product page view. Once per tab session and product is
  // all the reports need, since they count people, and it keeps a browsing shopper from
  // spending the per-IP event allowance.
  const oncePerSession = ['button_shown', 'button_seen'];
  // The collector rejects any other value, and a rejected event is lost, so only these go.
  const uiSources = ['thumbnail', 'mobile_chip', 'buy_box', 'gallery_link', 'deep_link', 'api'];
  const photoMethods = ['camera', 'library', 'last_photo'];
  let sessionId;
  function track(name, params = {}) {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === false || window.lampsPreviewBuild) return;
    const reachType = reachTypes[name];
    const eventType = eventTypes[name] || reachType;
    const jobId = params.room_job_id || params.job_id;
    const shareId = params.share_id;
    if (!eventType || (!reachType && !jobId && !shareId)) return;
    // view-in-room-form was renamed to view-in-room-gallery by the gallery-native work and
    // this selector was not updated, so root was null on every PDP and every event
    // returned early. real-rooms-strip carries the same attribute on pages without the
    // gallery. Match on the attribute first so a future rename cannot break it again.
    const root = document.querySelector('[data-worker-url]');
    if (!root?.dataset.workerUrl) return;
    try {
      const url = new URL(root.dataset.workerUrl, location.origin);
      if (url.protocol !== 'https:') return;
      url.pathname = `${url.pathname.replace(/\/$/, '')}/events`;
      url.search = '';
      url.hash = '';
      if (!sessionId) {
        try { sessionId = sessionStorage.getItem('lamps-room-event-session'); } catch { /* Optional storage. */ }
        if (!/^[a-f\d-]{36}$/i.test(sessionId || '')) sessionId = crypto.randomUUID();
        try { sessionStorage.setItem('lamps-room-event-session', sessionId); } catch { /* Optional storage. */ }
      }
      const body = { event_id: crypto.randomUUID(), session_id: sessionId, event_type: eventType };
      if (reachType) {
        const visitorId = window.LampsRoomStudio?.ownerId?.();
        if (!/^[a-f0-9]{32}$/.test(visitorId || '')) return;
        const productId = /^\d{1,24}$/.test(String(params.product_id || '')) ? String(params.product_id) : '';
        if (oncePerSession.includes(reachType)) {
          const key = `lamps-room-reach:${reachType}:${productId}`;
          try {
            if (sessionStorage.getItem(key)) return;
            sessionStorage.setItem(key, '1');
          } catch { /* Optional storage. */ }
        }
        body.visitor_id = visitorId;
        if (productId) body.product_id = productId;
        // The funnel splits (#1928). Device uses the same test as the desktop phone offer:
        // a tablet has a wide screen but a coarse pointer.
        const wide = window.matchMedia('(min-width: 768px)').matches;
        body.device = !wide ? 'phone' : window.matchMedia('(pointer: fine)').matches ? 'desktop' : 'tablet';
        if (['tool_opened', 'handoff_opened'].includes(reachType) && uiSources.includes(params.ui_source)) body.ui_source = params.ui_source;
        if (reachType === 'photo_selected' && photoMethods.includes(params.method)) body.method = params.method;
        if (reachType.startsWith('handoff_') && /^[a-zA-Z0-9_-]{1,64}$/.test(params.handoff_id || '')) body.handoff_id = params.handoff_id;
        void fetch(url.href, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true, credentials: 'omit' }).catch(() => {});
        return;
      }
      // Read, never minted: a shared-page visitor who has not used the tool has no id yet.
      try {
        const visitorId = localStorage.getItem('lamps:room-owner:v1');
        if (/^[a-f0-9]{32}$/.test(visitorId || '')) body.visitor_id = visitorId;
      } catch { /* Optional storage. */ }
      if (shareId) body.share_id = shareId;
      else body.job_id = jobId;
      if (eventType === 'rating') {
        if (!['up', 'down'].includes(params.rating)) return;
        body.rating = params.rating;
      }
      // Keep navigation responsive; no customer details, room photos, or free text.
      void fetch(url.href, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true, credentials: 'omit' }).catch(() => {});
    } catch { /* Analytics must never interrupt the shopper's flow. */ }
  }
  window.LampsRoomEvents = { track };
})();
